import posthog from 'posthog-js'

let cachedSessionId = null

function getPosthogSessionId () {
  if (!cachedSessionId) {
    try {
      cachedSessionId = posthog.get_session_id() ?? null
    } catch (_) { /* posthog not ready */ }
  }
  return cachedSessionId ?? ''
}

export function getTrackingHeaders () {
  return {
    'Ph-Session': getPosthogSessionId(),
    'Current-Page': window.location.href,
  }
}

export default {
  install (Vue) {
    Vue.prototype.$tracker = posthog.init(
      'phc_6J4IwnZgu4eo2YDrR9jB5ieoIJkkfMP0A09gegRFlxV',
      {
        api_host: 'https://us.i.posthog.com',
        defaults: '2026-01-30',
      }
    )
  },
}
